module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0050_approval_history")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.approveMode == 'reject',
      "type": "checkbox",
      "id": "checkBoxSelectAll",
      "name": "checkBoxSelectAll",
      "value": "X"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, "X") > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "click": function($event) {
        _vm.allChecked($event.target.value, $event.target)
      },
      "change": function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "X",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("\n            件数\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control limited-height-box",
    staticStyle: {
      "width": "5%",
      "text-align": "right",
      "float": "left",
      "margin-left": "5px"
    },
    attrs: {
      "type": "text",
      "data-cy": "totalNumberOfRows",
      "disabled": true
    },
    domProps: {
      "value": _vm.totalNumberOfRows
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050",
      "margin-right": "12px"
    },
    attrs: {
      "disabled": _vm.disablePageApprove || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkApprovalStage1
    }
  }, [_vm._v("承認")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.disablePageApprove || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkApprovalStage4
    }
  }, [_vm._v("申請クリア")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")])]), _vm._v(" "), (_vm.filteringRrejectMode == false) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "12px"
    },
    attrs: {
      "disabled": _vm.disablePageApprove || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkRejectStage1
    }
  }, [_vm._v("一括差戻")]) : _vm._e(), _vm._v(" "), (_vm.filteringRrejectMode == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.rejectedBulkEditDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.bulkEdit
    }
  }, [_vm._v(_vm._s(_vm.bulkEditText))]) : _vm._e()], 1), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runDeviceEmbededInformationDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage1ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage2ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage3
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "bulkApprovalStage4ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkClearApprovalStage4Confirmation
    }
  }), _vm._v(" "), _c('bulk-reject-modal', {
    attrs: {
      "tag": "bulkRejectModal"
    },
    on: {
      "closed": _vm.bulkRejectStage2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage2RejectConfirmatioModal"
    },
    on: {
      "done": _vm.bulkRejctStage3
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a263112","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub_pages/approval_history.vue
// module id = 930
// module chunks = 0